import { createFileRoute } from "@tanstack/react-router";

import {
	AboutSection,
	CareerSection,
	ContactSection,
	HeroSection,
	NewsSection,
	PartnersSection,
	PortfolioSection,
} from "@/components/home";
import { hotels, sectionIds } from "@/data/home";
import type { StrapiArticle } from "@/lib/articles";
import { getArticles } from "@/lib/articles";
import type { JobPosting } from "@/lib/jobPostings";
import { getJobPostings } from "@/lib/jobPostings";

export const Route = createFileRoute("/")({
	loader: async () => {
		const [articles, positions] = await Promise.all([
			getArticles("mk-MK"),
			getJobPostings("mk-MK"),
		]);
		return { articles, positions };
	},
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{ title: "Македонијатурист АД | Хотели во Скопје" },
			{
				name: "description",
				content:
					"Makedonijaturist AD - Најголемата хотелска групација во Скопје. Holiday Inn, Хотел Карпош, Хотел Турист, Хотел Bellevue. Локално срце, градски комфорт.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk",
			},
		],
		scripts: [
			{
				type: "application/ld+json",
				children: JSON.stringify({
					"@context": "https://schema.org",
					"@type": "Organization",
					name: "Македонијатурист АД",
					url: "https://makedonijaturist.com.mk",
					logo: "https://makedonijaturist.com.mk/logo512.png",
					contactPoint: {
						"@type": "ContactPoint",
						telephone: "+389-2-3114-105",
						contactType: "customer service",
					},
				}),
			},
		],
	}),
	component: HomePage,
});

export function HomePageContent({
	articles,
	positions,
}: {
	articles: StrapiArticle[];
	positions: JobPosting[];
}) {
	return (
		<main className="bg-cream">
			<HeroSection sectionIds={sectionIds} hotels={hotels} />
			<AboutSection sectionIds={sectionIds} />
			<PortfolioSection sectionIds={sectionIds} hotels={hotels} />
			<CareerSection sectionIds={sectionIds} positions={positions} />
			<PartnersSection sectionIds={sectionIds} />
			<NewsSection sectionIds={sectionIds} articles={articles} />
			<ContactSection sectionIds={sectionIds} />
		</main>
	);
}

function HomePage() {
	const { articles, positions } = Route.useLoaderData();
	return <HomePageContent articles={articles} positions={positions} />;
}
